import { useState } from 'react';
import { Button } from '@acb_devel/design-system';
import {
  PopoverRoot,
  PopoverTrigger,
  PopoverContent,
  PopoverClose,
} from '@acb_devel/design-system';
import { FilterButton } from '@components/assessors/atoms/FilterButton/FilterButton';
import { Field } from '@acb_devel/design-system';
import { ScrollArea } from '@acb_devel/design-system';
import { Checkbox } from '@acb_devel/design-system';
import { SearchIcon } from '@acb_devel/design-system';

import states from '@data/states.json';

import styles from './ProvincesFilter.module.scss';

export function ProvincesFilter({
  provinces,
  setProvinces,
}: {
  provinces: string[];
  setProvinces: (provinces: string[]) => void;
}) {
  const [selectedProvinces, setSelectedProvinces] =
    useState<string[]>(provinces);
  const [search, setSearch] = useState('');

  function handleApply() {
    setProvinces(selectedProvinces);
  }

  return (
    <PopoverRoot>
      <PopoverTrigger>
        <FilterButton>
          <strong>Provincias</strong>
          {provinces.length > 0 &&
            ` (${provinces.length}): ${provinces.join(', ')}`}
        </FilterButton>
      </PopoverTrigger>
      <PopoverContent align="start" sideOffset={10} paddingOff>
        <div className={styles.provincesFilter__popoverContent}>
          <div className={styles.provincesFilter__search}>
            <Field
              id="search"
              label=""
              placeholder="Buscar por..."
              value={search}
              onChange={(event) => setSearch(event.target.value)}
              prependSlot={<SearchIcon />}
            />
          </div>
          <ScrollArea className={styles.provincesFilter__scrollArea}>
            <div className={styles.provincesFilter__provincesList}>
              {states
                .filter((state) =>
                  state.name.toLowerCase().includes(search.toLowerCase())
                )
                .map((state) => (
                  <Checkbox
                    id={`province_${state.id}`}
                    key={state.id}
                    label={state.name}
                    checked={selectedProvinces.includes(state.name)}
                    onCheckedChange={(checked) => {
                      if (checked) {
                        setSelectedProvinces([
                          ...selectedProvinces,
                          state.name,
                        ]);
                      } else {
                        setSelectedProvinces(
                          selectedProvinces.filter(
                            (province) => province !== state.name
                          )
                        );
                      }
                    }}
                  />
                ))}
            </div>
          </ScrollArea>
          <div className={styles.provincesFilter__actions}>
            <PopoverClose>
              <Button
                variant="flat"
                color="primary"
                size="md"
                onClick={() => {
                  setSelectedProvinces([]);
                  setProvinces([]);
                }}
                upperCase={false}
              >
                Borrar
              </Button>
            </PopoverClose>
            <PopoverClose>
              <Button
                variant="solid"
                color="primary"
                size="md"
                onClick={handleApply}
                upperCase={false}
              >
                Aplicar
              </Button>
            </PopoverClose>
          </div>
        </div>
      </PopoverContent>
    </PopoverRoot>
  );
}
